import { processLoginResponse } from "../../util/login.js";
import { useAuthContext } from "../../hooks/use-auth-context.js";
import { useEffect, useRef } from "react";
import { Overlay } from "@myphx-engineering/phx-design-system";
import { jsx } from "react/jsx-runtime";
import { useNavigate, useSearchParams } from "react-router-dom";

//#region src/client/components/routes/LoginCallback.tsx
const LoginCallback = () => {
	const { clientId, redirectUri, rootUrl, tokenUrl } = useAuthContext();
	const isLoggingIn = useRef(false);
	const navigate = useNavigate();
	const [params] = useSearchParams();
	useEffect(() => {
		if (isLoggingIn.current) return;
		isLoggingIn.current = true;
		try {
			const code = params.get("code");
			const state = params.get("state");
			const loginError = params.get("error");
			window.history.replaceState(window.history.state, "", `${window.location.pathname}${window.location.hash}`);
			if (!code || !state || loginError) throw new Error(loginError ?? "Unknown login error");
			const runCallback = async () => {
				const response = await processLoginResponse({
					clientId,
					code,
					redirectUri,
					state,
					tokenUrl
				});
				if ("error" in response) {
					console.warn(response.error);
					if (response.errorDescription) console.warn(response.errorDescription);
					let err = response.error;
					if (response.errorDescription) err += ` -- ${response.errorDescription}`;
					throw new Error(err);
				}
				if (response.nextUrl && response.nextUrl !== "/") navigate(response.nextUrl, { replace: true });
				else navigate(rootUrl, { replace: true });
			};
			runCallback().catch((error) => {
				console.warn(error);
				navigate(rootUrl, { replace: true });
			});
		} catch (error) {
			console.warn(error);
			navigate(rootUrl, { replace: true });
		}
	}, [
		clientId,
		navigate,
		params,
		redirectUri,
		rootUrl,
		tokenUrl
	]);
	return /* @__PURE__ */ jsx(Overlay, { loader: true });
};

//#endregion
export { LoginCallback };